import React from "react";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

export const LegalShell = ({ title, children }) => (
  <div className="min-h-screen bg-[#F8FAFC] text-[#0F172A] font-body">
    <header className="bg-[#0A1220] border-b border-white/10">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 h-16 flex items-center justify-between">
        <Link to="/" className="flex items-center gap-2.5" data-testid="legal-logo">
          <img src="/teamtempus-logo.png" alt="Teamtempus" className="h-8 w-8 rounded-lg bg-white p-0.5" />
          <span className="font-heading font-bold text-white">Teamtempus</span>
        </Link>
        <Link to="/" className="inline-flex items-center gap-1.5 text-sm text-slate-300 hover:text-white transition-colors" data-testid="legal-back">
          <ArrowLeft className="h-4 w-4" /> Zurück
        </Link>
      </div>
    </header>
    <main className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-14">
      <h1 className="font-heading text-3xl sm:text-4xl font-extrabold tracking-tight">{title}</h1>
      <div className="mt-8 space-y-6 text-[#475569] leading-relaxed [&_h2]:font-heading [&_h2]:text-xl [&_h2]:font-semibold [&_h2]:text-[#0F172A] [&_h2]:mt-8 [&_h2]:mb-2 [&_strong]:text-[#0F172A] [&_a]:text-[#0284C7]">
        {children}
      </div>
    </main>
  </div>
);
